import type { OnDestroy, OnInit } from '@angular/core';
import {
  Directive,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { ModalService } from './modal.service';

@Directive({ standalone: true, selector: '[flModalTitle]' })
export class ModalTitleDirective implements OnInit, OnDestroy {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainerRef = inject(ViewContainerRef);
  private modalService = inject(ModalService);

  ngOnInit(): void {
    this.viewContainerRef.clear();
    this.modalService.setTitleTemplate(this.templateRef);
  }

  ngOnDestroy(): void {
    this.modalService.setTitleTemplate(undefined);
  }
}
